import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Tab, Tabs } from "@vds/tabs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import UsersTab from "./UsersTab";
import UserGroupsTab from "./UserGroupsTab";
import "./Users.css";

const Users = () => {
  const [currentTab, setCurrentTab] = useState("Users");

  const renderContent = () => {
    switch (currentTab) {
      case "Users":
        return <UsersTab />;
      case "User Group":
        return <UserGroupsTab />;
    }
  };

  return (
    <div className="users-page-container">
      <div id="test" style={{ display: "flex", marginBottom: "20px" }}>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link
              data-testid="users_settingsLink"
              to="/settings"
              className="breadcrums-item_link"
            >
              Settings
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>{currentTab}</BreadcrumbItem>
        </Breadcrumbs>
      </div>
      <h4 className="sasp_vz-nhg-eds-font users-page-title">
        {currentTab}
      </h4>
      <div className="users-tabs-container">
        <Tabs
          orientation="horizontal"
          indicatorPosition="bottom"
          fillContainer={false}
        >
          <Tab
            label={"Users"}
            data-testid="users_usersTab"
            onClick={() => {
              setCurrentTab("Users");
            }}
          />
          <Tab
            label={"User Groups"}
            data-testid="users_userGroupsTab"
            onClick={() => {
              setCurrentTab("User Groups");
            }}
          />
        </Tabs>
      </div>
      <div>{renderContent()}</div>
    </div>
  );
};

export default Users;
